import { render, staticRenderFns } from "./DriverDetailAdmin.vue?vue&type=template&id=51cadb74&"
import script from "./DriverDetailAdmin.vue?vue&type=script&lang=js&"
export * from "./DriverDetailAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports